import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

import { CamelCaseListing } from '../types'

const BannerWrapper = styled.div`
  ${typeStyle('-ds-font-caption-sm')}
  background-color: ${({ theme }) => theme?.['-ds-warning-200']?.value};
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 8px;
  text-align: center;
  margin-top: -5px;
  position: relative;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;

  strong {
    font-weight: 700;
  }
`
export const qualifiesForDiscountBanner = (
  discount: CamelCaseListing['discount'],
): boolean => {
  if (!discount) return false

  return (
    discount.percentage >= 10 &&
    (discount.typename !== 'LongStayDiscount' || discount.durationInNights >= 3)
  )
}

const DiscountBanner = ({
  discount,
}: {
  discount: CamelCaseListing['discount']
}) => {
  if (!qualifiesForDiscountBanner(discount)) return null

  return (
    <BannerWrapper>
      {discount.typename === 'LongStayDiscount' && 'Long stay '}
      <strong>{discount.percentage}% off</strong>
      {discount.typename === 'PromotionalDiscount' && ` ${discount.name}`}
    </BannerWrapper>
  )
}

export default DiscountBanner
